import 'css-chunk:src/feature/flip-and-tip/FlipAndTipEndPage.module.scss';export default {
  "main": "FlipAndTipEndPage_main",
  "tip_group": "FlipAndTipEndPage_tip_group",
  "tip_custom": "FlipAndTipEndPage_tip_custom",
  "hidden_field": "FlipAndTipEndPage_hidden_field",
  "submit_cta": "FlipAndTipEndPage_submit_cta",
  "visible": "FlipAndTipEndPage_visible",
  "disabled": "FlipAndTipEndPage_disabled",
  "email_field": "FlipAndTipEndPage_email_field",
  "sms_phone_code_field": "FlipAndTipEndPage_sms_phone_code_field",
  "sms_phone_field": "FlipAndTipEndPage_sms_phone_field"
};